import IResponse from '../../../../Utilities/Interfaces/IResponse'
import IOperationCanceler from '../SharedAbstractions/IOperationCanceler'
import ITermCreator from '../SharedAbstractions/ITermCreator'
import ITermListUpdateObserver from '../SharedAbstractions/ITermListUpdateObserver'
import ConstantFormPresenter from './ConstantFormPresenter'

class ConstantAddFormPresenter extends ConstantFormPresenter {
  constructor(
    operationCanceler: IOperationCanceler,
    private readonly creator: ITermCreator,
    termListUpdateObserver: ITermListUpdateObserver,
    private readonly companyId: number,
    displayDuration?: number
  ) {
    super(operationCanceler, 'Create', termListUpdateObserver, displayDuration)
  }

  public getCheckedStatus(): boolean {
    return true
  }

  protected getResponse(): Promise<IResponse> {
    return this.creator.create({
      company_id: this.companyId,
      value: Number.parseFloat(this._value),
      type: 'constant',
      name: this._name,
      isActiveVariable: true
    })
  }

  public isSaveEnabled(): boolean {
    const value = Number.parseFloat(this._value)
    return !!this._name && !Number.isNaN(value)
  }
}

export default ConstantAddFormPresenter
